import React from "react";
import styled from "styled-components";
import ExtraInfo from "src/components/ExtraInfo";
import { addCommas } from "src/storage/helpers";
import { Button } from "@mui/material";
import { Users } from "react-feather";

const Item = styled(Button)`
  width: 200px;
  flex-shrink: 0;
  height: 100%;
  padding: 12px;
  background-color: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border: ${(props) =>
    props.$isActive ? "2px solid #337ab7" : "2px solid transparent"};

  &:hover {
    background-color: #faf9f6;
  }
`;

const IconContainer = styled.div`
  svg {
    transition: 200ms ease-in;
    color: ${(props) => (props.$isActive ? "white" : "black")};
    height: 22px;
    width: 22px;
    min-height: 22px;
    min-width: 22px;
    padding: 4px;
    background-color: ${(props) =>
      props?.$isActive ? "#337ab7" : "#eeeeee90"};
    border-radius: 8px;
    border: 1px solid #eeeeee;
  }
`;

const ClickableItem = ({
  title,
  value,
  Icon = Users,
  isActive,
  setActiveFilter,
  explanationText = null,
}) => {
  return (
    <Item onClick={() => setActiveFilter(title)} $isActive={isActive}>
      <IconContainer $isActive={isActive}>
        <Icon />
      </IconContainer>
      <div
        style={{
          display: "flex",
          gap: 4,
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <span
          style={{
            fontSize: 12,
            fontWeight: 400,
            color: isActive ? "#337ab7" : "slategrey",
          }}
        >
          {title}
        </span>
        {explanationText && (
          <ExtraInfo text={explanationText} overrideBlack={!isActive} />
        )}
      </div>
      <span
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: isActive ? "#337ab7" : "black",
        }}
      >
        {addCommas(value)}
      </span>
    </Item>
  );
};

export default ClickableItem;
